import { useAuthStore } from '@/stores/authStore';

import logger from "./secureLogger";
/**
 * Logout utility that doesn't depend on React Router
 * Useful for components that might render outside Router context
 */
export const performLogout = async () => {
  try {
    logger.debug("🚪 performLogout: Starting logout process...");
    
    // Get logout function from store
    const { logout: storeLogout } = useAuthStore.getState();
    
    // Perform logout through store
    await storeLogout();
    
    // Always use window.location for navigation
    logger.debug("🔄 Redirecting to login page...");
    window.location.href = '/login';
    
  } catch (error) {
    logger.error("❌ performLogout: Logout error:", error);
    
    // Even if logout fails, redirect to login for security
    window.location.href = '/login';
  }
};

/**
 * Emergency logout - clears everything and redirects
 * Use when other logout methods fail
 */
export const emergencyLogout = () => {
  try {
    logger.debug("🚨 Emergency logout initiated...");
    
    // Clear all localStorage
    localStorage.clear();
    sessionStorage.clear();
    
    // Clear auth store state
    const { resetAuthState } = useAuthStore.getState();
    resetAuthState();
    
    // Redirect to login
    window.location.href = '/login';
    
  } catch (error) {
    logger.error("❌ Emergency logout error:", error);
    // Force redirect even if clearing fails
    window.location.href = '/login';
  }
};

export default { performLogout, emergencyLogout };
